import { SportDataGatewayQueryInfo, SportDataGatewayStreamInstance } from "sb-resp-lib";
import { IPersonalizationMethodResponse } from "../Interfaces";
import { observable } from "mobx";
import { entities, EventPushResponse } from "sbtech-sports-data-api-client";

export const initialSportsDataFeed: EventPushResponse = {
    data: {
        add: {
            events: [],
            markets: []
        },
        change: {
            events: [],
            markets: []
        },
        remove: {
            events: [],
            markets: []
        }
    }
};

export const failureSportsDataFeed: EventPushResponse = {
    data: {
        add: {
            events: [],
            markets: []
        },
        change: {
            events: [],
            markets: []
        },
        remove: {
            events: [],
            markets: []
        }
    }
};

/*
    The class has 'istanbul ignore' flag , because of testing typescript interface with Jest.
    It`s known issue : (https://github.com/kulshekhar/ts-jest/issues/378)
    The class is fully tested, but propery "sportsDataChangeFeed" implement interface "ChangeFeedUpdate" which is not
    testable with Jest - there is no types like in typescript
 */

/* istanbul ignore next */
export class SportDataGateWayRetriever {
    uniqueId: string;
    localeCodeQueryFormat: string;
    @observable sportsDataChangeFeed: EventPushResponse | undefined;
    @observable shouldRemoveEvents: boolean;

    constructor(localeCodeId: string = "en", uniqueId: string = "personalized-highlights-sportsdata-retriever") {

        this.localeCodeQueryFormat = localeCodeId;
        this.sportsDataChangeFeed = initialSportsDataFeed;
        this.uniqueId = uniqueId;
        this.shouldRemoveEvents = false;

        this.messageHandler = this.messageHandler.bind(this);
    }

    activate(personalizationData: IPersonalizationMethodResponse) : void
    {
        let eventsQuery = this.queryBuilder(personalizationData);
        let queryInfo = new SportDataGatewayQueryInfo(eventsQuery, this.messageHandler);
        queryInfo.initialData = "true";
        queryInfo.locale = this.localeCodeQueryFormat;

        SportDataGatewayStreamInstance.subscribeForEvents({
            id: this.uniqueId,
            entityType: entities.EntityType.Event,
            queryInfo
        });
    }

    setFailureSportsDataChangeFeed(eventIds: number[]): void {
        this.shouldRemoveEvents = true;
    }

    deactivate(): void {
        SportDataGatewayStreamInstance.unsubscribe(entities.EntityType.Event, this.uniqueId);
    }

    messageHandler(data: EventPushResponse): void {
        this.shouldRemoveEvents = false;
        // Observed by Data Facade for changes
        this.sportsDataChangeFeed = data;
    }

    queryBuilder(personalizationMethodResponse: IPersonalizationMethodResponse): string {
        /* istanbul ignore next */
        let sportDataApIQuery = "$filter=isLive eq false and id in (";

        personalizationMethodResponse.BranchGroups.forEach(function (branch) {
            branch.Events.forEach(function (event) {
                if (branch.Id !== 0) {
                    sportDataApIQuery += `'${event.Id}',`;
                }
            });
        });

        sportDataApIQuery = sportDataApIQuery.slice(0, -1) + ")";

        return sportDataApIQuery;
    }
}
